import environment from "src/environment/environment";
import { RefImageTypeEnum, ShapeEnum, LengthUnitEnum } from "src/shared/enum";
import * as Yup from 'yup';

export interface IRealSizeViewerFormFields {
    length: Number;
    width: Number;
    height: Number;
    unit: LengthUnitEnum;
    shape: ShapeEnum;
    objectImage: any;
    referenceImageType: RefImageTypeEnum;
    referenceImage: any;
    referenceImageHeight: Number;
    referenceImageWidth: Number;
}

export const GetRealSizeViewerFormInitialValues = (): IRealSizeViewerFormFields => {
    return {
        length: 1,
        width: 1,
        height: 1,
        unit: LengthUnitEnum.Feet,
        shape: ShapeEnum.Box,
        objectImage: null,
        referenceImageType: RefImageTypeEnum.Default,
        referenceImage: null,
        referenceImageHeight: 6,
        referenceImageWidth: 2
    }
}

export const GetRealSizeViewerFormValidationSchema = (t: any, referenceImageType: RefImageTypeEnum, objectImageType: ShapeEnum, unitSelected: LengthUnitEnum) => {
    let objImgMaxDimension = getMaxValueForDimension(unitSelected);
    return Yup.object().shape({
        length: Yup.number().min(environment.realSizeFormMinValue).max(objImgMaxDimension).required(t('label-required')),
        width: Yup.number().min(environment.realSizeFormMinValue).max(objImgMaxDimension).required(t('label-required')),
        height: Yup.number().min(environment.realSizeFormMinValue).max(objImgMaxDimension).required(t('label-required')),
        unit: Yup.string().trim().required(t('label-required')),
        shape: Yup.string().trim().required(t('label-required')),
        objectImage: objectImageType !== ShapeEnum.Box ? Yup.mixed().required(t('label-required')) : Yup.mixed().nullable(),
        referenceImageType: Yup.string().trim().required(t('label-required')),
        referenceImage: referenceImageType !== RefImageTypeEnum.Default ? Yup.mixed().required(t('message-ref-img-required')) : Yup.mixed().nullable(),
        referenceImageHeight: Yup.number().min(environment.realSizeFormMinValue).required(t('label-required')),
        referenceImageWidth: Yup.number().min(environment.realSizeFormMinValue).required(t('label-required'))
    })
}

// Returns max value limit for dimensions on basis of unit selected
const getMaxValueForDimension = (unit: LengthUnitEnum) => {
    let value = 1;
    switch (unit) {
        case LengthUnitEnum.CentiMeter:
            value =  12 * 30.48;
            break;
        case LengthUnitEnum.Feet:
            value = 12;
            break;
        case LengthUnitEnum.Inch:
            value = 12 * 12;
            break;
        case LengthUnitEnum.Meter:
            value = 12 * 0.3048;
            break;
    }
    return Number(value.toFixed(2));
}